<div class="wrapper" (scroll)="scrollHandler($event)">
	<app-header [state]="headerState"></app-header>
	<div class="page-container">
		<!-- <app-loading-overlay></app-loading-overlay> -->
		<router-outlet> </router-outlet>
	</div>
	<!-- <app-menu></app-menu> -->
	<app-footer></app-footer>
</div>
